import { Link } from 'react-router-dom';
import { toAbsoluteUrl } from '@/utils/Assets';
import { useUser } from "@/contexts/UserContext";
import { useEffect } from "react";

const Welcome = () => {
    const { user, refreshUser } = useUser();

    useEffect(() => {
        // Only refresh if user data is not available
        if (!user) {
            refreshUser();
        }
    }, [user, refreshUser]);

    // Show a loading state while user data is being fetched
    if (!user) {
        return (
            <div className="card">
                <div className="card-body px-10 py-7.5 lg:pr-12.5">
                </div>
            </div>
        );
    }

    return (
        <div className="card">
            <div className="card-body px-10 py-7.5 lg:pr-12.5">
                <div className="flex flex-wrap md:flex-nowrap items-center gap-6 md:gap-10">
                    <div className="flex flex-col gap-3">
                        <h1 className="text-2xl font-semibold text-gray-900">
                            Hi {user.firstName}, welcome to Buddy
                        </h1>
                        <h2 className="text-1xl font-semibold text-gray-900">
                            Start your journey to a simpler, smarter hiring process.
                        </h2>

                        <p className="text-sm text-gray-700 leading-5.5">
                            At UPFLINX Buddy, we help HR professionals like you make hiring smarter and more efficient.
                            Whether you're sorting candidates, matching them to job descriptions, or organizing your
                            hiring process, we’re here to save you time and effort.
                        </p>

                        <p className="text-sm text-gray-700 leading-5.5">
                            Don't worry if you're new to AI – we’ve designed everything to be simple and intuitive, with
                            plenty of support to help you get started.
                        </p>
                    </div>

                    <img
                        src={toAbsoluteUrl('/media/images/avatar-high.png')}
                        className="dark:hidden max-h-[250px]"
                        alt="Avatar"
                    />
                </div>
            </div>

            {/*<div className="card-footer justify-center">
                <Link to="/network/get-started" className="btn btn-link">
                    Get Started
                </Link>
            </div>*/}
        </div>
    );
};

export { Welcome };
